import { createContext, useContext, type ReactNode } from "react";

/** Populated when the request host matches a business's
 *  `dashboard_custom_domain`. Lets Auth + dashboard surfaces brand themselves
 *  and skip the noknok-pro chrome.
 *
 *  Null on every regular host (noknok.pro, *.noknok.pro storefront subdomains,
 *  and the Canvas/Websites custom domains). */
export interface CustomDashboardDomainInfo {
    businessId: string;
    businessName: string;
    subdomain: string | null;
    logoUrl: string | null;
    faviconUrl: string | null;
    primaryColor: string | null;
}

const Ctx = createContext<CustomDashboardDomainInfo | null>(null);

export function CustomDashboardDomainProvider({
    value,
    children,
}: {
    value: CustomDashboardDomainInfo | null;
    children: ReactNode;
}) {
    return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

/** Returns the bound business's branding when the visitor is on a
 *  dashboard custom domain; null otherwise. Components use this to decide
 *  between the noknok-pro shell and the white-labelled CRM shell. */
export function useCustomDashboardDomain(): CustomDashboardDomainInfo | null {
    return useContext(Ctx);
}
